export default "__VITE_ASSET__BaoDO21T__"